import { SnackbarProvider } from 'notistack';
import React from 'react';

export function ProvideSnackbar({ children }: React.PropsWithChildren<{}>) {
    return <SnackbarProvider dense>{children}</SnackbarProvider>;
}
